import { useQuery } from '@apollo/client';
import { isEmpty, isNil } from 'lodash';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

export function useViewTemplate(
  workflowTemplateId?: string | null,
  viewTemplateId?: string | null,
): {
  viewTemplate?: API.ViewTemplateFragment;
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery<
    API.GetViewTemplateQuery,
    API.GetViewTemplateQueryVariables
  >(Queries.viewTemplate.getViewTemplate, {
    variables: {
      input: {
        workflowTemplateId: workflowTemplateId ?? '',
        id: viewTemplateId ?? '',
      },
    },
    skip: isNil(workflowTemplateId) || isEmpty(viewTemplateId),
  });

  return {
    viewTemplate: data?.getViewTemplate as API.ViewTemplateFragment | undefined,
    loading,
    error,
  };
}
